import { colors, Stack, Typography } from '@ui-components/neo.tax';

import { HeroContainer } from './analysis-hero.styled';

interface AnalysisHeroProps {
  title: React.ReactNode;
  subtitle?: string;
  children?: React.ReactNode;
}

export const AnalysisHero = ({ children, subtitle, title }: AnalysisHeroProps): React.ReactElement => (
  <HeroContainer direction="column" alignItems="center" justifyContent="center" gap={8}>
    <Stack direction="column" space={4} paddingY={18}>
      <Typography as="h1" color="white" fontSize="4xl" fontWeight="bold" textAlign="center">
        {title}
      </Typography>
      {subtitle && (
        <Typography as="p" color={colors.blue[100]} fontSize="lg">
          {subtitle}
        </Typography>
      )}
    </Stack>
    {children}
  </HeroContainer>
);
